import React, {memo} from 'react'
import {goBack} from '../../util'
import {withErrorHandling, withHelmet, withPropsPresent, withUserData, withUsersData} from '../../hoc'
import {RemovalConfirmationModal} from '../shared'
import {removeUser} from '../../backend'

const _RemoveUser = (
  {
    user,
    history,
    navigate,
    removeUser,
    mutateUsers,
    basePath = '/c/account/users'
  }
) => {
  const onRemovalConfirmed = async (user) => {
    await removeUser(user)
    mutateUsers()
    navigate(basePath)
  }

  if (!user) {
    return null
  }

  return (
    <RemovalConfirmationModal
      confirmingRemovalOf='user'
      propName='email'
      expectedPropValue={user.email}
      onRemovalApproved={async () => onRemovalConfirmed(user)}
      onRemovalCancelled={() => goBack(history, navigate, basePath)}/>
  )
}

let RemoveUser = (props) => {
  const {handleError} = props
  props = {...props, removeUser: handleError(removeUser)}
  return (<_RemoveUser {...props}/>)
}

RemoveUser = withHelmet(RemoveUser, 'Remove User')
RemoveUser = withPropsPresent(RemoveUser, ['users', 'user'])
RemoveUser = withUserData(RemoveUser, 'Loading user...')
RemoveUser = withUsersData(RemoveUser, 'Loading users...')
RemoveUser = withErrorHandling(RemoveUser)
RemoveUser = memo(RemoveUser)

export {_RemoveUser, RemoveUser}

export default RemoveUser